import { render, staticRenderFns } from "./uploadProduct.vue?vue&type=template&id=c792959c&scoped=true"
import script from "./uploadProduct.vue?vue&type=script&lang=js"
export * from "./uploadProduct.vue?vue&type=script&lang=js"
import style0 from "./uploadProduct.vue?vue&type=style&index=0&id=c792959c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c792959c",
  null
  
)

export default component.exports